'use strict';

function WeatherNameFilter() {
  return weather_code => {
    switch (true) {
      case /2\d\d/.test(weather_code):
        return '雷雨';
      case /3\d\d/.test(weather_code):
        return '霧雨';
      case /5\d\d/.test(weather_code):
        return '雨';
      case /6\d\d/.test(weather_code):
        return '雪';
      case /7\d\d/.test(weather_code):
        return '霧';
      case /800/.test(weather_code):
        return '快晴';
      case /80\d/.test(weather_code):
        return '曇り';
      case /9\d\d/.test(weather_code):
        return '特殊';
    }
  }
}

export default angular.module('leptonApp.WeatherName', [])
  .filter('weather-name', [WeatherNameFilter])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/weather-name/weather-name.filter.js